<div class="small-modal-container" [ngClass]="{'active': modalVisible}" (click)="toggle()">
    <div class="modal-content ">{{modalMessage}}</div>
</div>

